export default function RegisterPage() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">회원가입</h1>
        <p className="text-gray-600">새 계정을 만들어 서비스를 시작하세요.</p>
      </div>
    </div>
  )
}